import Field from '../Field';

class Boolean extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    this.value.forEach((val, index) => {
      if (force || this.validIndex[index]) {
        const value = !!val;
        this.setValue(value, index);
        this.setDisplayValue(value, index);
      }
    });

    return this;
  }
}

export default Boolean;
